import { useState } from "react";
import * as InfiniteScroll from "react-infinite-scroller";
import useCache from "../../hooks/use-cache";
import { useGetNewsQuery } from '../../store';
import PostTiny from "./posts/PostTiny";

export default function Dashboard({ category }) {

    const [pageIdentifier, setPageIdentifier] = useState(0);
    const [posts, setPosts] = useState([]);
    const [contextCategory, setCategory] = useState();

    const cacheKey = `news-${category}-${pageIdentifier}`;
    const results = useCache(cacheKey, useGetNewsQuery, { id: category, pageIdentifier });

    const loadMorePosts = function () {
        if (posts?.length > 0) {
            const lastPost = posts[posts.length - 1];
            setPageIdentifier(lastPost.pageId);
        }
    }

    if (category !== contextCategory) {
        setPosts([]);
        setPageIdentifier(0);
        setCategory(category);
        return;
    }

    const newPosts = results.data || [];
    const postsToAdd = newPosts.filter(np => !posts.some(p => p.id === np.id) && (contextCategory === 'all' || np.categories.includes(contextCategory)));
    if (postsToAdd.length) {
        const newPostsResult = [...posts, ...postsToAdd];

        setPosts(newPostsResult);
        return;
    }

    const postsRendered = posts.map((p) => {
        return <PostTiny key={p.id} post={p}></PostTiny>
    });

    return (

        <InfiniteScroll loadMore={loadMorePosts} hasMore={true}>
            <div className="news-dashboard">
                {postsRendered}
            </div>
        </InfiniteScroll>
    );
}